import { useQuery } from '@tanstack/react-query';
import { devStandardsApi } from '../api/devStandardsApi';

/**
 * GET /api/eraf/standards/active
 * queryKey: ['dev-standards', 'active']
 *
 * 404 (STD-404-001) → data = null, isEmpty = true (에러 아님)
 * 5xx / 네트워크 오류 → isError = true
 */
export function useActiveStandards() {
  const query = useQuery({
    queryKey: ['dev-standards', 'active'],
    queryFn: () => devStandardsApi.getActive(),
    staleTime: 30_000,
    retry: (failureCount, error) => {
      // 404 는 재시도하지 않음
      const e = error as { code?: string };
      if (e?.code === 'STD-404-001' || e?.code === 'HTTP-404') return false;
      return failureCount < 2;
    },
  });

  return {
    ...query,
    isEmpty: !query.isLoading && !query.isError && query.data === null,
  };
}
